import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import Box from './Box';
import Flex from './Flex';
import Select from './form/Select';
import XIcon from './icons/XIcon';
import LinkButton from './LinkButton';
import Text from './Text';
const AlgoliaMultiSelectRefinement = /*#__PURE__*/React.memo(_ref => {
  let {
    attribute,
    items,
    limit,
    options,
    placeholder,
    refine,
    transformLabel
  } = _ref;
  const values = items.filter(_ref2 => {
    let {
      isRefined
    } = _ref2;
    return isRefined;
  }).map(_ref3 => {
    let {
      label
    } = _ref3;
    return label;
  });
  const handleAdd = React.useCallback(value => {
    if (value && value !== '') refine([...values, value]);
  }, [refine, values]);
  const handleRemove = React.useCallback(value => refine(values.filter(v => v !== value)), [refine, values]);
  return /*#__PURE__*/React.createElement(Box, null, values.map(value => /*#__PURE__*/React.createElement(Flex, {
    key: value,
    alignContent: "center",
    mb: 2
  }, /*#__PURE__*/React.createElement(LinkButton, {
    onClick: () => handleRemove(value),
    sx: {
      color: 'red',
      opacity: 0.75,
      fontSize: 1,
      mr: 2,
      ':hover,:focus': {
        color: 'red',
        opacity: 1
      }
    }
  }, /*#__PURE__*/React.createElement(XIcon, {
    size: 12
  })), /*#__PURE__*/React.createElement(Text, {
    fontSize: 1
  }, transformLabel(value)))), values.length < limit && /*#__PURE__*/React.createElement(Select, {
    value: "",
    onChange: _ref4 => {
      let {
        target: {
          value
        }
      } = _ref4;
      return handleAdd(value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholder), options.filter(_ref5 => {
    let {
      value
    } = _ref5;
    return !values.includes(value);
  }).map(_ref6 => {
    let {
      label,
      value
    } = _ref6;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  })));
});
AlgoliaMultiSelectRefinement.propTypes = {};
AlgoliaMultiSelectRefinement.defaultProps = {
  transformLabel: val => val
};
AlgoliaMultiSelectRefinement.displayName = 'AlgoliaMultiSelectRefinement';
export default connectRefinementList(AlgoliaMultiSelectRefinement);